import profileRequest from '@stelecom/ui-react/components/requests/profileRequestIntegration';

interface PaymentInfoParams {
    floatRecSum?: number
}

export interface IPaymentInfo {
    balance: number,
    paySum: number,
    payDay: string,
    bindingCards: unknown[],
    promisedPayment: unknown[],
    promisedPaymentInfo: IPromisedPaymentInfo,
    payText: string,
    payChargesSum: string,
    payTextParam: string,
    payPeriodDates: string,
    payCurBalance: string,
    payIsDeny: boolean,
    isAllow: number
}

/**
 * @param domain
 * @param accessToken
 * @param params
 */
export async function getPaymentInfo(domain: string, accessToken: string, params: PaymentInfoParams = {}): Promise<IPaymentInfo> {
    const resp = await profileRequest(
        domain, accessToken,
    ).get('/info/payment', { params });
    // console.log(resp.data);
    return parseResponse(resp.data);
}

/**
 * @param data
 */

function parseResponse(data: any): IPaymentInfo {
    return {
        balance: +data.balance,
        paySum: +data.paySum,
        payDay: data.payDay,
        bindingCards: data.bindingCards,
        // массив с чем-то
        promisedPayment: data.promisedPayment,
        promisedPaymentInfo: parsePromisedPaymentInfo(data.promisedPaymentInfo),
        payText: data.payText,
        payChargesSum: data.payChargesSum,
        payTextParam: data.payTextParam,
        // строка с месяцем ?
        payPeriodDates: data.payPeriodDates,
        payCurBalance: data.payCurBalance,
        // boolean ?
        payIsDeny: !!data.payIsDeny,
        isAllow: data.isAllow
    };
}

export interface IPromisedPaymentInfo {
    code: number,
    promisedPaymentBal: IPromisedPaymentBalance
}

/**
 * @param data
 * @return {{code: *, promisedPaymentBal: {auto: *, payForDay: *, activeTo: *,
 *   day: *}}}
 */
function parsePromisedPaymentInfo(data: any) {
    return {
        code: data.code,
        promisedPaymentBal: parsePromisedPaymentBalance(data.promisedPaymentBal),
    };
}

export interface IPromisedPaymentBalance {
    payForDay: unknown,
    day: unknown,
    activeTo: unknown,
    activeToTimestamp: unknown,
    auto: unknown
}

/**
 * @param data
 * @return {{auto: *, payForDay: *, activeTo: *, day: *}}
 */
function parsePromisedPaymentBalance(data: any): IPromisedPaymentBalance {
    if (data === null) {
        return {
            payForDay: null,
            day: null,
            activeTo: null,
            activeToTimestamp: null,
            auto: null,
        };
    }
    return {
        payForDay: data.payForDay,
        day: data.day,
        activeTo: data.activeTo,
        auto: data.auto,
        activeToTimestamp: data.activeToTimestamp
    };
}
